import { createSlice } from '@reduxjs/toolkit'
import { DeviceType, getDeviceType } from '../helpers/device'
import {
  setDeviceType,
  setDeviceWidth,
} from '@wellesley/host-remote/api/actions'

type UiState = {
  deviceType: DeviceType
  deviceWidth: number | null
}

const initialState: UiState = {
  deviceType: getDeviceType(),
  deviceWidth: window.innerWidth,
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setDeviceType, (state, { payload }) => {
      state.deviceType = payload
    })
    builder.addCase(setDeviceWidth, (state, { payload }) => {
      state.deviceWidth = payload
    })
  },
  selectors: {
    selectDeviceType: (state) => state.deviceType,
    selectDeviceWidth: (state) => state.deviceWidth,
    selectIsMobile: (state) => state.deviceType === 'mobile',
    selectIsTablet: (state) => state.deviceType === 'tablet',
    selectIsDesktop: (state) => state.deviceType === 'desktop',
  },
})
